import * as React from "react";

function SvgEdit(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><g fill="currentColor"><path d="M1.658 14.631h12.685V16H1.658zM14.2 3.4a.521.521 0 00.146-.34.438.438 0 00-.146-.34L11.669.146a.527.527 0 00-.729 0L9.434 1.652l3.256 3.257zM12.009 5.54L8.753 2.333 1.658 9.428v3.208h3.256z" /></g></svg>;
}

const ForwardRef = React.forwardRef(SvgEdit);
export default ForwardRef;